const FALLBACK_MESSAGE =
  "You have view-only access. Ask a company admin to make you a member to create, upload, edit, or process work.";

/**
 * The server's message for a reviewer's refused write (`READ_ONLY_ACCESS`), or null for any other
 * error. A personal role limit, kept apart from the company-level `ORGANIZATION_ACCESS_REQUIRED`.
 */
export function getReadOnlyAccessMessage(error: unknown): string | null {
  if (typeof error !== "object" || error === null || !("data" in error)) return null;
  const data = error.data;
  if (typeof data !== "object" || data === null || !("code" in data) || data.code !== "READ_ONLY_ACCESS") {
    return null;
  }
  return "message" in data && typeof data.message === "string" && data.message.trim()
    ? data.message
    : FALLBACK_MESSAGE;
}
